/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */


export const ON_PROGRESS_DATA = 'boilderplate/UploadProgress/ON_PROGRESS_DATA'

export const LOADER_STATUS = 'boilderplate/UploadProgress/LOADER_STATUS'

export const SET_PASS_PAGE = 'boilerplate/UploadProgress/SET_PASS_PAGE'

export const SET_TOTAL_RECORD = 'boilderplate/UploadProgress/SET_TOTAL_RECORD';

export const SET_TABLE_DATA = 'gstr3b/SET_TABLE_DATA';